import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Typography } from '@mui/material';
import React from 'react';
import { useCommonDataTableUiTranslation } from '../../hooks';
export const TableTitle = ({ title, filteredRowCount, totalRowCount }) => {
    const { t } = useCommonDataTableUiTranslation();
    let rowCountText;
    if (filteredRowCount != null && totalRowCount != null) {
        rowCountText = t('rowCountOf', { filteredRowCount, totalRowCount });
    }
    else if (filteredRowCount != null) {
        rowCountText = t('rowCount', { count: filteredRowCount });
    }
    else if (totalRowCount != null) {
        rowCountText = t('rowCount', { count: totalRowCount });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: 'subtitle1', sx: { display: 'inline', whiteSpace: 'nowrap' } }, title),
        rowCountText && (React.createElement(Typography, { variant: 'body2', sx: { display: 'inline', ml: 1, whiteSpace: 'nowrap', color: themeColors.text.subtle } }, rowCountText))));
};
